import axios from "../../interceptors/axiosInterceptor";
import { CREATE_CAMPAIGN, GET_CAMPAIGN, UPDATE_CAMPAIGN } from "config/Url";
import {
  ICampaign,
  IFetchCampaignActionResponse,
  ICreateCampaignRequestPayload,
} from "interfaces/Index";
import { normalizeCatchErrors } from "utils/errorUtils";
import { getAuthOptions } from "config/Headers";
import { SOMETHING_WENT_WRONG } from "config/constants";
import { IGetQueryParams } from "interfaces/Index";

export const createCampaignApiCall = (
  payload: ICreateCampaignRequestPayload
) => {
  return new Promise<any>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    axios
      .post(CREATE_CAMPAIGN, payload, requestConfig)
      .then((response) => {
        if (response) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const getCampaignsApiCall = (queryParam: IGetQueryParams = {}) => {
  return new Promise<IFetchCampaignActionResponse>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(GET_CAMPAIGN, requestConfig)
      .then((response) => {
        if (response) {
          const campaigns: ICampaign[] = response?.data?.body || [];
          const pageNumber = queryParam.pageNo ? Number(queryParam.pageNo) + 1 : 1;
          const pagination = campaigns.length === 50 ? pageNumber : false;
          const isPaginatedRes = queryParam.pageNo && (queryParam.pageNo as any) > 0 &&
          campaigns.length >= 50 ? true : false;
          resolve({
            campaigns,
            pagination,
            isPaginatedRes,
          });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const updateCampaignApiCall = (campaignId: string) => {
  return new Promise<void>((resolve, reject) => {
    let url = UPDATE_CAMPAIGN.replace("{campaign_id}", campaignId);
    axios
      .patch(url, null, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        }
      })
      .catch(() => {
        reject({ errors: SOMETHING_WENT_WRONG });
      });
  });
};
